import intlTelInput from 'intl-tel-input';
import Cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', () =>
{
    const forms = document.querySelectorAll('.js-ci-leads');
    forms.forEach(form =>
    {
        const formId = form.id;
        if (!formId) {
            console.error('Form is missing id attribute.');
            return;
        }

        const httpMethod = form.method;
        const baseUrl = form.dataset.baseUrl;
        // const actionUrl = form.action;
        const actionUrl = form.dataset.actionUrl;
        const tokenUrl = form.dataset.tokenUrl;
        const errorUrl = form.dataset.errorUrl;
        const submitEl = form.querySelector('button.js-action_dosubmit');
        // const secIdEl = form.querySelector('input.js-securityid');
        if (!httpMethod || !baseUrl || !actionUrl || !tokenUrl || !errorUrl || !submitEl) {
            console.error('Action attributes or submitter not present.');
            return;
        }

        const failedEl = form.querySelector('.js-leads-failure');
        const failedMessageEl = failedEl.querySelector('.js-leads-failure-message');
        if (!failedEl || !failedMessageEl) {
            console.error('Feedback elements not present.');
            return;
        }

        const itiPhoneField = form.querySelector('input.js-phone-field');
        const countryField = form.querySelector('select.js-country');
        const stateField = form.querySelector('select.js-state');
        const stateOtherField = form.querySelector('input.js-stateother');
        if (!itiPhoneField || !countryField || !stateField || !stateOtherField) {
            console.error('Important fields cannot be found.');
            return;
        }

        const geoIpCountry = Cookies.get('ci_gipc') || 'AU';
        const phoneOptionsJSON = itiPhoneField.dataset.intltelinputOptions || '';
        const phoneOptionsData = phoneOptionsJSON ? JSON.parse(phoneOptionsJSON) : {};
        const phoneOptions = {
            loadUtils: () => import('intl-tel-input/utils'),
            geoIpLookup: (cb) => cb(geoIpCountry),
            ...phoneOptionsData,
        };
        const iti = intlTelInput(itiPhoneField, phoneOptions);

        const doesCountryHaveStateSelection = (country) => {
            return country === 'Australia' || country === 'New Zealand';
        };

        const refreshStateFields = () =>
        {
            const value = countryField.value;
            const stateOptions = stateField.querySelectorAll('option');
            if (doesCountryHaveStateSelection(value)) {
                stateOptions.forEach(stateOption => stateOption.hidden = stateOption.dataset.country !== value && stateOption.value !== '');
                stateField.style.display = 'inline-block';
                stateOtherField.style.display = 'none';
                stateOtherField.value = '';
            }
            else if (!value) {
                stateOptions.forEach(stateOption => stateOption.hidden = false);
                stateField.style.display = 'inline-block';
                stateOtherField.style.display = 'none';
                stateOtherField.value = '';
            }
            else {
                stateOptions.forEach(stateOption => stateOption.hidden = false);
                stateField.style.display = 'none';
                stateField.value = '';
                stateOtherField.style.display = 'inline-block';
            }

            const selectedState = stateField.selectedOptions[0];
            if (selectedState && selectedState.hidden) {
                stateField.value = '';
            }
        };

        if (geoIpCountry) {
            if (geoIpCountry === 'AU') {
                countryField.value = 'Australia';
            }
            else if (geoIpCountry === 'NZ') {
                countryField.value = 'New Zealand';
            }
            else if (geoIpCountry === 'GB') {
                countryField.value = 'United Kingdom';
            }
            else {
                countryField.value = 'Other';
            }
        }
        refreshStateFields();
        countryField.addEventListener('change', e => refreshStateFields());

        const refreshCountryField = () =>
        {
            if (countryField.value) {
                return;
            }
            const selectedState = stateField.selectedOptions[0];
            if (selectedState) {
                countryField.value = selectedState.dataset.country;
            }
        };
        stateField.addEventListener('change', e => refreshCountryField());

        let errorData = {
            context: {},
        };

        const doLogFormError = (message, formMessage) =>
        {
            resetFormErrorMessage(formMessage);
            console.error(message);
            console.log(errorData);
            return;

            const data = {
                message: message,
                formMessage: formMessage,
                formId: formId,
                error: {}
            };

            if (errorData.error) {
                data.error.stack = errorData.error.stack;
                data.error.message = errorData.error.message;
                data.error.string = String(errorData.error);
            }

            fetch(baseUrl +'/'+ errorUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(data),
            })
                .catch(reportErr => console.error(
                    'Failed to report error',
                    {errorUrl: errorUrl, error: reportErr}
                ));
        }

        const resetFormErrorMessage = (message) =>
        {
            failedMessageEl.textContent = message;
            failedEl.style.display = (message) ? 'block' : 'none';
        }

        const getFieldName = (field) =>
        {
            let fieldName = field.name;
            if (!fieldName) {
                fieldName = field.dataset.fieldName;
            }
            return fieldName;
        };

        const setFormIsNotSubmittable = () =>
        {
            submitEl.classList.remove('is-processing');
            submitEl.innerHTML = 'Submit';
            submitEl.disabled = true;
        }

        const setFormIsSubmittable = (doIfProcessing = false) =>
        {
            if (!doIfProcessing && submitEl.classList.contains('is-processing')) {
                return;
            }
            submitEl.classList.remove('is-processing');
            submitEl.innerHTML = 'Submit';
            submitEl.disabled = false;
        }

        const setFormIsSubmitting = () =>
        {
            submitEl.classList.add('is-processing');
            submitEl.innerHTML = 'Submitting...';
            submitEl.disabled = true;
        }

        const bouncer = new Bouncer('#'+formId,
        {
            disableSubmit: true,
            customValidations:
                {
                    intlPhoneNumber: function (field)
                    {
                        let isInvalid = true;
                        if (field.value) {
                            // console.log(iti.getNumber());
                            // console.log(iti.isValidNumber());
                            // console.log(iti.getNumberType());
                            // console.log(iti.getValidationError());
                            isInvalid = !iti.isValidNumber();
                        }
                        return isInvalid;
                    },
                    stateProvince: function (field)
                    {
                        let isInvalid = true;
                        const countryValue = countryField.value;
                        if (!countryValue) {
                            isInvalid = false;
                        }
                        else if (!doesCountryHaveStateSelection(countryValue)) {
                            isInvalid = false;
                        }
                        else if (field.value) {
                            const selectedStateOption = field.selectedOptions[0];
                            isInvalid = countryValue !== selectedStateOption.dataset.country;
                        }
                        else {
                            isInvalid = true;
                        }
                        return isInvalid;
                    },
                },
        });

        const doFormSubmit = (e) =>
        {
            e.preventDefault();

            resetFormErrorMessage('');
            setFormIsSubmitting();

            if (!bouncer.isFormValid(form)) {
                setFormIsNotSubmittable();
                return;
            }

            const formData = new FormData(form);
            formData.set(itiPhoneField.name, iti.getNumber());

            let formErrorMessage = 'Sorry, something went wrong. Please refresh and try again.';

            fetch(baseUrl +'/'+ tokenUrl, {
                method: httpMethod,
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            })
                .then(response => response.json())
                .then(data => {
                    if (data.token) {
                        formData.set('SecurityID', data.token);
                        console.log(data.token);
                        console.log(Array.from(formData.entries()));
                    }
                    else {
                        throw new Error('Token collect failed.');
                    }
                })
                .then(() => {
                    return fetch(baseUrl +'/'+ actionUrl, {
                        method: httpMethod,
                        headers: {
                            'Accept': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: formData,
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        if (data.redirect) {
                            // window.open(data.redirect, '_blank', 'noopener,noreferrer')
                            window.location = data.redirect;
                            return;
                        }
                        const message = data.message || 'Thank you for filling out the form. One of our friendly staff will be in contact soon!';
                        form.outerHTML = '<p class="ci-lead-form__message">'+ message + '</p>';
                        return;
                    }
                    else if (data.status === 'error') {
                        throw new Error(`Submit failed: ${data.message}`);
                    }
                    else if (data.status === 'invalid') {
                        const invalids = data.messages;
                        if (invalids && invalids.length > 0) {
                            invalids.forEach(invalid => {
                                const errorFieldName = invalid.fieldName;
                                const errorFieldMessage = invalid.message;
                                if (errorFieldName && errorFieldMessage) {
                                    const errorFieldEl = form.querySelector('input[name="${errorFieldName}"]');
                                    if (errorFieldEl) {
                                        formErrorMessage = '';
                                        bouncer.showError(errorFieldEl, {serverMessage: invalid.message});
                                    }
                                }
                            });
                            throw new Error(`Server invalidated submission`);
                        }
                        else {
                            throw new Error(`Submit invalid without validation messages`);
                        }
                    }
                    throw new Error(`Server response badly formatted`);
                })
                .catch(error => {
                    errorData.error = error;
                    setFormIsSubmittable(true);
                    doLogFormError(error.message, formErrorMessage);
                });
        }

        form.addEventListener('bouncerFieldsValid', (e) => {
            setFormIsSubmittable();
        });

        form.addEventListener('bouncerFieldValid', (e) =>
        {
            resetFormErrorMessage('');
            const field = e.target;
            const fieldName = getFieldName(field);
            if (fieldName === 'Country') {
                bouncer.validate(stateField);
            }
        });

        form.addEventListener('bouncerFieldInvalid', (e) =>
        {
            // setFormIsNotSubmittable();
            resetFormErrorMessage('');
            const field = e.target;
            const fieldName = getFieldName(field);
        });

        form.addEventListener('submit', doFormSubmit);

        const init = () =>
        {
            // if (bouncer.isFormValid(form)) {
            //     setFormIsSubmittable();
            // } else {
            //     setFormIsNotSubmittable();
            // }
        }

        init();
    });
});
